<script lang="ts">
  import { userbaseStore } from "../../stores/stores";
  import { createEventDispatcher } from "svelte";
  import Button from "../../shared/Button.svelte";
  import Input from "../../shared/Input.svelte";
  import type { Entry } from "../../stores/types";
  import moment from "moment";

  export let inventoryItem: Entry, itemId: string;
  let dispatch = createEventDispatcher();
  let fieldAmount = 0;
  let updatePromise = null;
  let databaseName = "inventory";
  let fieldDate = moment().format("yyyy-MM-DD");

  const submitHandler = () => {
    if (fieldAmount > 0) {
      inventoryItem.amount = Number(inventoryItem.amount) + Number(fieldAmount);
      inventoryItem.lastAdded = new Date(fieldDate);
      updatePromise = $userbaseStore.updateItem({
        databaseName,
        itemId,
        inventoryItem,
      });
      var logItem = {
        action: "update-add",
        changedItem: inventoryItem,
      };
      updatePromise = $userbaseStore.insertItem({
        databaseName: "logs",
        item: logItem,
      });
      dispatch("updateItem");
    } else {
      alert("Bitte Menge angeben");
    }
  };
</script>

<form class="form" on:submit|preventDefault={submitHandler}>
  <h2>Eingekauft?</h2>
  <Input
    label="Name"
    value={inventoryItem.article.item.name}
    type="text"
    disabled
  />
  <Input
    label="Menge"
    bind:value={fieldAmount}
    type="number"
    min="100"
    required
  />
  <Input
    label="Haltbar bis"
    bind:value={inventoryItem.bestBefore}
    type="date"
    required
  />
  <Input label="gekauft am" bind:value={fieldDate} type="date" required />
  <Button type="secondary" flat={true}>Zufluss eintragen</Button>
</form>
